import { toast } from '@/shared/lib/toast';
import { createContext, Fragment, useCallback, useEffect, useMemo } from 'react';
import { useSnackbarStore } from 'stores/snackbar/snackbar.store';
import { CreateSnackbarHandler, SnackbarContextProps, SnackbarContextProviderProps } from './types';

export const DEFAULT_TIMEOUT_DURATION = 5000;

const initialState: SnackbarContextProps = {
  createSnackbar: () => '',
};

export const SnackbarContext = createContext<SnackbarContextProps>(initialState);

export const SnackbarContextProvider = ({ children }: SnackbarContextProviderProps) => {
  const setCreateSnackbar = useSnackbarStore((state) => state.setCreateSnackbar);

  const createSnackbar = useCallback<CreateSnackbarHandler>((label, config) => {
    let callToast = toast.success;

    if (config?.variant === 'danger') callToast = toast.error;
    if (config?.variant === 'warning') callToast = toast.warning;
    if (config?.variant === 'success') callToast = toast.success;
    if (config?.variant === 'loading') callToast = toast.info;

    return callToast(label, {
      duration: config?.duration ? `${config.duration}ms` : undefined,
      persist: config?.persist,
      title: config?.title,
    });
  }, []);

  useEffect(() => {
    setCreateSnackbar(createSnackbar);
  }, [createSnackbar, setCreateSnackbar]);

  const valueMemoized = useMemo(() => {
    return { createSnackbar };
  }, [createSnackbar]);

  return (
    <Fragment>
      <SnackbarContext.Provider value={valueMemoized}>{children}</SnackbarContext.Provider>
    </Fragment>
  );
};
